export const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat('vi-VN', {
    style: 'currency',
    currency: 'VND',
  }).format(amount);
};

/** Số tiền dạng 116.000 (không kèm đơn vị tiền) — dùng bảng chi tiết hóa đơn */
export const formatAmountDots = (amount: number): string => {
  return new Intl.NumberFormat('vi-VN', { maximumFractionDigits: 0 }).format(amount);
};

export const formatDate = (date: string): string => {
  return date.split('-').reverse().join('/');
};

